import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { InterceptorSkipHeader } from '@core/http-interceptors/headers-interceptor.service';

const headers = new HttpHeaders().set(InterceptorSkipHeader, '');

@Injectable({
  providedIn: 'root'
})
export class CustomTicketApplicationService {
  protected url = '/api/Tickets';

  constructor(protected http: HttpClient) { }

  createTicketsWithImage(formData: FormData) {
    if (formData)
      return this.http.put(`${environment.webApiBaseAddress}${this.url}/CreateTicket`, formData, { headers, reportProgress: true, observe: 'events' });
  }
}
